<template>
  <router-link :to="`/properties/view/${property.id}`">
    <div class="property-list-style grid grid-cols-5 mb-6">
      <div class="p-3 col-span-2">
        <div
          class="image"
          :style="
            `background-image: url(${baseImageUrl}/storage/${
              property.photos.length ? property.photos[0].image : ''
            });`
          "
        >
          <div class="overlay"></div>
        </div>
      </div>
      <div class="p-5 py-3 mb-2 col-span-3">
        <div class="flex items-center justify-between">
          <div class="tags">
            <ul>
              <li>{{ LISTING_TYPES[property.listing_type] }}</li>
              <li v-if="property.is_advertised">Featured</li>
            </ul>
          </div>
          <div class="price">
            &euro;{{ property.price }} <small class="font-normal"> monthly</small>
          </div>
        </div>
        <p class="mb-1 capitalize">
          {{ property.property_type.classification }} -
          {{ property.property_type.name }}
        </p>
        <h4 class="font-bold mb-2">{{ property.city.name }}</h4>
        <p class="mb-5">
          {{ property.description }}
        </p>
        <ul>
          <li>Baths: {{ property.main_bathrooms + property.ensuites }}</li>
          <li>Beds: {{ property.bedrooms }}</li>
        </ul>
      </div>
    </div>
  </router-link>
</template>

<script>
import { LISTING_TYPES } from "@/constants";
export default {
  props: ["property"],
  data: function() {
    return {
      LISTING_TYPES,
      baseImageUrl: process.env.VUE_APP_API_URL,
    };
  },
};
</script>

<style lang="scss" scoped>
.team-member {
  width: 50px;
  height: 50px;
  background-position: 67px 95px;
  background-size: 120px 120px;
  background-image: url("~@/assets/darren.jpg");
  border-radius: 100%;
}

.property-list-style {
  @apply bg-white border border-gray-400 rounded-lg;

  .image {
    @apply relative rounded-lg overflow-hidden w-full;
    height: 290px;
    background-size: cover !important;
    background-position: center !important;

    .overlay {
      @apply absolute top-0 w-full h-full bg-black bg-opacity-50 text-white;
    }
  }

  .tags {
    @apply text-white py-4;

    ul li {
      @apply inline-block bg-black px-3 py-1 text-xs rounded-md mr-2;

      &:last-child {
        @apply text-black bg-primary-color;
      }
    }
  }
  .price {
    @apply text-2xl;
  }

  ul li {
    @apply inline-block pr-8;
  }
}
</style>
